export enum STARS_ACCOUNT_TYPE_ENUM {
  STARS = 'STARs',
  REFERRAL_PROGRAM_PROVIDER_ADMIN = 'Referral Program Provider Admin',
  STARS_PROVIDER_ADMIN = 'STARs Provider Admin'
}
